module.exports = __webpack_public_path__ + "static/img/gift.591d81c.png";